'use strict';

var React = require('react');
var classNames = require('classnames');
var _ = require('lodash');
var InvestmentAllocationActions = require('../../actions/InvestmentAllocationActions');
var InvestmentAllocationStore = require('../../stores/InvestmentAllocationStore');
var ApplicationActions = require('../../actions/ApplicationActions');
var Keyboard = require('../../utils/Keyboard');

var InvestmentAllocatedTable = React.createClass({
    keyValidate: function (e) {
        if (!Keyboard.isNumberKey(e)) {
            e.preventDefault(); 
        }
    },

    setQtyFormat: function (qty) {
        var num = !isNaN(qty) ? new Number(qty) : 0;
        return num.toFixed(2);
    },

    handleOfFocus: function (index, e) {
        var qty = this.setQtyFormat(e.target.value);
        InvestmentAllocationActions.updateInvestmentOption(qty, index);
        ApplicationActions.sendInvestmentOptions(_.clone(this.props.allocatedInvestmentOptions));
        if (this.props.isAdd) {
            this.props.toggleIsAdd(false);
        }
    },

    handleChange: function (index, e) {
        var qty = e.target.value;
        InvestmentAllocationActions.updateInvestmentOption(qty, index);
        InvestmentAllocationActions.removeSelectedPortfolioList(true, InvestmentAllocationStore.getList(), InvestmentAllocationStore.getFirstRateCashNonAutoRebalancing());
        ApplicationActions.sendInvestmentOptions(_.clone(this.props.allocatedInvestmentOptions));
    },

    removeInvestmentOption: function (selectedIndex) {        
        var data = this.props.allocatedInvestmentOptions;
        InvestmentAllocationActions.removeInvestmentOption(data[selectedIndex]);        
        InvestmentAllocationActions.removeSelectedPortfolioList(true, InvestmentAllocationStore.getList(), InvestmentAllocationStore.getFirstRateCashNonAutoRebalancing());
        InvestmentAllocationActions.toggleFirstRateCashNonAutoRebalancingOption(InvestmentAllocationStore.getFirstRateCashNonAutoRebalancing()); 
    },

    noCopyPaste: function (e) {
        if (!Keyboard.noCopyPaste(e)) {
            e.preventDefault();
        }
    },

    componentDidUpdate: function(prevProps) {
        if (this.props.allocatedInvestmentOptions.length > prevProps.allocatedInvestmentOptions.length){
            this.refs['ia' + (this.props.allocatedInvestmentOptions.length - 1)].focus();
        }
        if (!_.isEqual(this.props.allocatedInvestmentOptions, prevProps.allocatedInvestmentOptions)) {
            ApplicationActions.sendInvestmentOptions(_.clone(this.props.allocatedInvestmentOptions));
        }
    },

    render: function () {
        var investmentOptions = function (data, index) {
            return (
                <tr key={data.id} className={classNames('table-add', {'has-warning': (data.weight <=0 && !this.props.hasError) || this.props.highlightInput})} >
                    <td className="table-title">{data.name}</td>
                    <td className="table-title">{(!data.minTimeframe || data.minTimeframe.trim() === '') ? 'N/A' : data.minTimeframe}</td>
                    <td className="table-title">{(!data.riskLabel || data.riskLabel.trim() === '') ? 'N/A' : data.riskLabel}</td>
                    <td className="table-code">{data.code}</td>
                    <td className="text-right">      
                                          
                    <input ref={`ia${index}`} autoComplete="off" disabled={data.disabled} className="form-control input-lg input-investment external-account-4" style={{float: 'none',width: '125px'}} value={data.weight} 
                        onChange={this.handleChange.bind(this, index)} id={'iaInvestmentOption' + index} onKeyPress={this.keyValidate} onKeyDown={this.noCopyPaste} onBlur={this.handleOfFocus.bind(this, index)} maxLength="6" />

                        <a className="table-cancel" onClick={this.removeInvestmentOption.bind(this, index)}><i className="icon icon-cancel"></i></a>                 
                    </td>
                </tr>
            );
        };
        return (         
            <table className={classNames('table table-single investment-allocation-table', { hidden: this.props.investmentListAvailable })} id="table-allocations" >
                <thead>
                    <tr>
                        <td className="column-heading">Name<span className="hidden-xs"></span></td>
                        <td className="column-heading">Minimum Suggested Timeframe<span className="hidden-xs"></span></td>
                        <td className="column-heading">Risk Rating<span className="hidden-xs"></span></td>
                        <td className="column-heading"><span className="hidden-xs">Code</span></td>
                        <td className="column-heading text-right"><span className="visible-xs-inline investment-header-xs">PCT. (%)</span><span className="investment-header hidden-xs">Investment %</span></td>
                    </tr>
                </thead>
                <tbody>
                    {this.props.allocatedInvestmentOptions.map(investmentOptions, this)}
                </tbody>
            </table>

            );
    }
});

module.exports = InvestmentAllocatedTable;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/InvestmentAllocation/InvestmentAllocatedTable.jsx